'use client'

import cx from 'classnames'
import React, { useEffect, useRef, useState } from 'react'

import '@/components/LandingPage/ContentModel/Box/Accordion/Accordion.scss'

export default function Accordion({
  title,
  children,
  initOpen = false,
}: {
  title: string
  children: React.ReactNode
  initOpen?: boolean
}) {
  const [open, setOpen] = useState(true)
  const [height, setHeight] = useState(0)
  const ref = useRef<HTMLDivElement>(null)

  useEffect(() => {
    if (ref.current && ref.current.offsetHeight > height) {
      setHeight(ref.current.offsetHeight)
    }
    if (!initOpen) {
      setOpen(initOpen)
    }
  }, [])

  return (
    <div
      className={cx('p-info__list-item', {
        'p-info__list-item--open': open,
      })}
    >
      <div className="p-info__list-heading u-mo-lineView u-mo-crop" onClick={() => setOpen((prevState) => !prevState)}>
        <h3 className="p-info__list-heading-title u-font-yu-go">
          <span className="u-mo-lineView__text u-mo-crop__container">
            <span className="u-mo-crop__text u-mo-crop__text--inner">{title}</span>
            <span className="u-mo-crop__text u-mo-crop__text--outer">{title}</span>
          </span>
        </h3>
        <figure className="p-info__list-heading-cross" />
      </div>
      <div className="p-info__list-contents" ref={ref} style={height > 0 ? { height: open ? height : 0 } : {}}>
        <div className="p-info__list-contents-inner">
          <div className="p-info__list-contents-block">
            <div className="p-info__list-cassette p-info__list-cassette--detail u-font-yu-go">{children}</div>
          </div>
        </div>
      </div>
    </div>
  )
}
